/**
 * FCC status codes for 601 applications.
 */
export enum FccStatusEnum {
    AGranted = 'A Granted',
    Accepted = 'Accepted',
    Dismissed = 'Dismissed',
    Granted = 'Granted',
    PendingLevel2 = 'Pending - Level 2',
    Returned = 'Returned',
}

export const FccFilterStatuses: FccStatusEnum[] = Object.values(FccStatusEnum);
